import { Env } from './environment.model';
/**
 * Prod environment
 */
export const environment: Env = {
    key: '9075f6cd-3271-4ebb-9514-1c74b6c17f22',
    production: true,
    envName: 'prod',
    cacheDuration: 3600,
    availableLanguages: ['ar', 'de', 'en', 'en-IN', 'es', 'fr', 'hi', 'it', 'ru', 'vi', 'zh-CN', 'zh-TW'],
    responsibilitiesIds: [
        'c621894d-1008-454d-b2bb-ad7d791da134',
        '8cd4ba7f-9463-4547-87d0-b05277a9bf23',
        'cbabb241-a56c-4508-9658-f3114bdb86bb',
        '400dc46c-c711-4285-880c-6078b2b8f5b9',
        '8684205a-f3d1-4ce4-b381-c229e17c0882',
    ],
    exchangeAdminUrl: 'https://admin-exchange.decathlon.net/',
    openSatisfactionPopup: true,
    authorizationRedirectUrl: 'https://decathlon-exchange.decathlon.com/',
    oauthConfig: {
        production: true,
        stsAuthority: 'https://idpdecathlon.oxylane.com',
        clientId: 'C4f245b59a599341fdf5c1561939d1d10d2016781',
        clientRoot: window.location.origin,
        clientScope: 'openid profile',
    },
    exchangeApi: {
        url: 'https://api.decathlon.net/nexchange_api/api/',
    },
    s3Client: 'https://storage.googleapis.com/exchange-v2-prod/',
    mediaUrl: 'https://storage.googleapis.com/exchange-v2-prod/media/',
    catalogExchangeUuid: '07b0d4a2-9229-4125-9672-9c16057a44f1',
    catalogClientId: 'Cb20bf0e719fe2586be5e539bb6eef809caa4e263',
    gaMeasurementId: 'UA-117670695-3',
    phrase: {
        url: 'https://api.phrase.com/v2/projects/8fc2dc7541638cb97edbb42246d1f329/',
        token: 'token ' + '68f26bdfcedacb3e2662996fcc3c393c5997ece72c6c699fe78b2e47ebad53b3',
    },
    maintenanceMode: false,
    maintenanceEmails: [],
    bealink: 'https://university.decathlon.com/',
    datadog: {
        applicationId: 'a7cef634-7c74-4f2c-9425-9d7354ba98a9',
        clientToken: 'pub12a5189a65c488d704cc43da0b2799fc',
        site: 'datadoghq.eu',
        env: 'production',
        version: 'master-202606301237-f56fdde',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
    },
};
